import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import i18n from '~/i18n'

export const syncLocalLanguagesPairs = async (newLocalLanguagesPairs: [string, string][]) => {
  for (const [source, learn] of newLocalLanguagesPairs)
    await apiClient
      .PATCH('/user/languages', {
        body: { source, learn },
      })
      .catch(error => {
        toast.error(i18n.t('Network error'))
        console.error({ message: 'Network error', error })
      })
}
